import React from 'react';
import { connect } from 'react-redux';
import BoxInput from './BoxInput';
import { createStructuredSelector } from 'reselect';
import CardInput from './CardInput';
import * as selectors from '../../../../../../modules/customer/profile/hardwareProducts/selectors'

const AddHardwareStep1 = ({isMatchingHardware}) => {
    return (
        <div className="add-hardware col-xs-12 col-md-12">
            <div className="row">
                <div className="col-md-6 col-xs-12">
                    <BoxInput />
                </div>
                <div className="col-md-6 col-xs-12">
                    <CardInput />
                </div>
            </div>
            {!isMatchingHardware &&
                <div className="alert alert-danger">
                    Incorrect hardware pair(ie SMB2 and ProgramCard1 or SMB2/ProgramCard3 and no ProgramCard3/SMB2)
                </div>
            }
        </div>
    )};

const mapStateToProps = createStructuredSelector({
    isMatchingHardware: selectors.isMatchingHardwareEquipment,
});

export default connect(mapStateToProps)(AddHardwareStep1);